module.exports = __webpack_public_path__ + "static/media/greatProject.1abc10fd.jpg";